// The picture beside the console's sign-in form: the console as mission control — QOR in the middle of what it runs
// (programs, cardholders, the processors), signals travelling between them, and a feed of the kind of lines its logs
// hold. Decoration only: the lines are made up and hidden from screen readers; the words under it are read.

/** The drawing's own units (the SVG's viewBox); a node's place is a share of them. */
const WIDTH = 560;
const HEIGHT = 360;
const HUB = [280, 180] as const;

const NODES = [
  { label: 'Programs', at: [92, 62], tone: 'accent' },
  { label: 'Cardholders', at: [64, 196], tone: 'blue' },
  { label: 'Transactions', at: [132, 318], tone: 'accent' },
  { label: 'InterCash', at: [452, 56], tone: 'blue' },
  { label: 'MDP', at: [500, 190], tone: 'accent' },
  { label: 'Audit log', at: [424, 316], tone: 'blue' },
] as const;

const FEED = [
  ['09:41:07', 'LOAD', 'approved', '+$250.00'],
  ['09:41:12', 'ACTIVATE', 'card ••7649', 'ok'],
  ['09:41:20', 'PROBE', 'InterCash', '23 ms'],
] as const;

const wire = (at: readonly [number, number]) => `M${HUB[0]} ${HUB[1]} L${at[0]} ${at[1]}`;

export function ConsoleShowcase() {
  return (
    <div className="showcase console-showcase">
      <div className="console-art" aria-hidden="true">
        <div className="console-network">
          <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`}>
            {NODES.map((node) => (
              <path key={node.label} className={`console-wire console-wire-${node.tone}`} d={wire(node.at)} />
            ))}
            {NODES.map((node, i) => (
              <circle
                key={node.label}
                className={`console-signal console-signal-${node.tone}`}
                r="3.5"
                style={{ offsetPath: `path('${wire(node.at)}')`, animationDelay: `${i * -0.9}s` }}
              />
            ))}
          </svg>

          <div className="console-hub" style={{ left: '50%', top: '50%' }}>
            <span>QOR</span>
          </div>
          {NODES.map((node) => (
            <div
              key={node.label}
              className={`console-node console-node-${node.tone}`}
              style={{ left: `${(node.at[0] / WIDTH) * 100}%`, top: `${(node.at[1] / HEIGHT) * 100}%` }}
            >
              <i></i>
              {node.label}
            </div>
          ))}
        </div>

        <div className="console-feed">
          <div className="console-feed-bar">
            <i></i>
            <i></i>
            <i></i>
            <span>live activity</span>
          </div>
          {FEED.map(([time, what, who, result]) => (
            <div className="console-feed-line" key={time}>
              <span>{time}</span>
              <b>{what}</b>
              <span>{who}</span>
              <strong>{result}</strong>
            </div>
          ))}
        </div>
      </div>

      <div className="showcase-copy">
        <p className="eyebrow">QOR Console</p>
        <h2>
          Mission control
          <br />
          for card programs.
        </h2>
        <p>Programs, processors, cardholders and every transaction, in one place and fully audited.</p>
      </div>
    </div>
  );
}
